import { TRole } from "../model/IRole";

// --
export type TPageUrl =
| '/oauth/signIn'
| '/orders'
| '/unshipped-orders'
| '/late-orders'
| '/orders-by-date'
| '/orders-by-vendor'
| '/orders-by-vehicle'
| '/orders-by-part-type'
| '/orders-by-status'
| '/orders-by-website'
| '/orders-by-state'
| '/orders-by-dma'
| '/orders-by-payment-type'
| '/shipping-carriers'
;

type IAccess<T extends string | number | symbol> = {
  [key in T]: (Partial<TRole | '*'>)[];
};

// --
// -- Access map
// --
// -- These have to agree with the backend. Every order endpoint this app calls
// -- is @PreAuthorize("hasAnyRole('ADMIN','VENDOR','AGENT')") and narrows its
// -- results to the caller's supplier keys, so a vendor is meant to be here and
// -- sees only their own orders. Leaving ROLE_VENDOR out did not hide anything
// -- - it locked vendors out of the app entirely, in a redirect loop.
// --
// -- '*' is never a role a user actually holds, so a page listing only '*' is
// -- reachable but never "granted" - the sign in route does not gate on access.
// --
export const pagesAccess: IAccess<TPageUrl> = {
  '/oauth/signIn':   ['*'],
  '/orders':         ['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_VENDOR'],
  // -- Both report endpoints are hasAnyRole('ADMIN','VENDOR','AGENT') and
  // -- narrow to the caller's supplier keys, as the CS portal has them.
  '/unshipped-orders':    ['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_VENDOR'],
  '/late-orders':         ['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_VENDOR'],
  '/orders-by-date':   ['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_VENDOR'],
  '/orders-by-vendor':  ['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_VENDOR'],
  '/orders-by-vehicle':   ['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_VENDOR'],
  '/orders-by-part-type': ['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_VENDOR'],
  '/orders-by-status':    ['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_VENDOR'],
  '/orders-by-website':   ['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_VENDOR'],
  '/orders-by-state':     ['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_VENDOR'],
  '/orders-by-dma':       ['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_VENDOR'],
  '/orders-by-payment-type': ['ROLE_ADMIN', 'ROLE_AGENT', 'ROLE_VENDOR'],
  // -- Admin only, as in the CS portal. The backend keeps creating, editing
  // -- and deleting carriers to ADMIN; only the list itself is open wider, so
  // -- the tracking form's shipper dropdown can read it.
  '/shipping-carriers':      ['ROLE_ADMIN'],
};
